import React from 'react';
import Layout from 'antd/lib/layout';
import 'antd/lib/layout/style/index.css';
import PageMenu from '../PageMenu';
var PageAside = function (props) { return (React.createElement(Layout.Sider, { className: props.className, collapsible: false, width: '24rem' },
    React.createElement(PageMenu, null))); };
export default PageAside;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageAside/index.tsx
// module id = 802
// module chunks = 0